import { render } from "./Quiz.vue?vue&type=template&id=a8040e44&scoped=true"
import script from "./Quiz.vue?vue&type=script&lang=js"
export * from "./Quiz.vue?vue&type=script&lang=js"

import "./Quiz.vue?vue&type=style&index=0&id=a8040e44&scoped=true&lang=css"

import exportComponent from "/home/bshipaa/sites/app.bitesizehipaa.com/bss/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8040e44"]])

export default __exports__